import "./style.scss";

const CustomRadio = (props) => {
  const { label, onSelected, data, selected = 1 } = props;
  return (
    <div className="custom-radio">
      <label className="container">
        {label}
        <input
          type="radio"
          name="radio"
          value={selected}
          checked={data.id === selected}
          onChange={() => onSelected(data)}
        />
        <span className="checkmark" />
      </label>
    </div>
  );
};
export default CustomRadio;
